import { Pipe, PipeTransform } from '@angular/core';
import { ReviewFileStatus } from '@common/reviews/enums/review-file-status.enum';

@Pipe({
  name: 'mcReviewFileStatusColorClass'
})
export class ReviewFileStatusColorClassPipe implements PipeTransform {
  transform(status: ReviewFileStatus | null | undefined, style: 'bg' | 'border' | 'fill', luminosity: '' | 'muted' | 'vivid' = ''): string {
    switch (status) {
      case ReviewFileStatus.Open:
        return `mc-${style}-caution${luminosity ? '-' + luminosity : ''}`;
      case ReviewFileStatus.Closed:
      case ReviewFileStatus.Accepted:
        return `mc-${style}-info${luminosity ? '-' + luminosity : ''}`;
    }
  }
}
